var _a;
import { createSlice } from '@reduxjs/toolkit';
export var possibleHeaders = {
    project: 'project',
    minimalProject: 'minimalProject',
    projectBacked: 'projectBacked',
    levelBuilderSave: 'levelBuilderSave',
};
var initialState = {
    currentHeader: undefined,
    getLevelBuilderChanges: undefined,
    overrideHeaderText: undefined,
    overrideOnSaveUrl: undefined,
};
var headerSlice = createSlice({
    name: 'header',
    initialState: initialState,
    reducers: {
        showProjectHeader: function (state) {
            state.currentHeader = possibleHeaders.project;
        },
        showMinimalProjectHeader: function (state) {
            state.currentHeader = possibleHeaders.minimalProject;
        },
        showProjectBackedHeader: function (state) {
            state.currentHeader = possibleHeaders.projectBacked;
        },
        showLevelBuilderSaveButton: {
            reducer: function (state, action) {
                state.currentHeader = possibleHeaders.levelBuilderSave;
                state.getLevelBuilderChanges = action.payload.getChanges;
                state.overrideHeaderText = action.payload.overrideHeaderText;
                state.overrideOnSaveUrl = action.payload.overrideOnSaveUrl;
            },
            prepare: function (getChanges, overrideHeaderText, overrideOnSaveUrl) {
                return { payload: { getChanges: getChanges, overrideHeaderText: overrideHeaderText, overrideOnSaveUrl: overrideOnSaveUrl } };
            },
        },
        clearHeader: function (state) {
            state.currentHeader = undefined;
        },
    },
});
export var showProjectHeader = (_a = headerSlice.actions, _a.showProjectHeader), showMinimalProjectHeader = _a.showMinimalProjectHeader, showProjectBackedHeader = _a.showProjectBackedHeader, showLevelBuilderSaveButton = _a.showLevelBuilderSaveButton, clearHeader = _a.clearHeader;
export default headerSlice.reducer;
